<template>
  <!-- <div
    style="
      background: url('/img/bg-1.png') no-repeat center fixed;
      background-size: cover;
      overflow-x: hidden;
    "
  > -->
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page">
        <div class="content">
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3">
              <card style="background-color: white; box-shadow: none">
                <div class="row">
                  <div class="col-lg">
                    <h3
                      slot="header"
                      style="margin-bottom: -15px; color: #358CCB"
                    >
                      Reset Your Password
                    </h3>
                    <el-divider></el-divider>
                    <p style="color: #b9b9b9">
                      Please enter your email address.
                    </p>
                  </div>
                </div>
                <br />
                <div class="row text-center">
                  <div class="col-lg">
                    <base-input
                      :inputStyle="inputstyle"
                      v-model="recoveremail"
                      placeholder="Your email"
                      required
                      type="text"
                    ></base-input>
                    <p style="color: #fb0000; font-size: 12px">
                      {{ recovertext }}
                    </p>
                  </div>
                </div>

                <div class="col-lg-12" style="margin-top: 10px">
                  <div class="row text-right">
                    <div class="col-lg">
                      <base-button type="danger" v-on:click="getLogin()"
                        >Back</base-button
                      >

                      <base-button type="primary" v-on:click="forgetpassword()"
                        >Reset</base-button
                      >
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Divider } from "element-ui";
import { BCard } from "bootstrap-vue";

export default {
  name: "ForgotPassword",
  components: {
    [Divider.name]: Divider,
    BCard,
  },
  data() {
    return {
      recovertext: "",
      recoveremail: "",

      inputstyle:
        "height: 35px;  border-radius: 50px; border: 1px solid #e3e3e3;",
    };
  },
  methods: {
    getLogin() {
      this.$router.push("/login");
    },
    forgetpassword() {
      let obj = {
        email: this.recoveremail,
      };

      this.$http.post(":10001/api/v1/password/forgot", obj).then((res) => {
        let response = res.message;

        if (!res.error) {
          console.log(response);

          this.recovertext = response;
        } else if (res.error) {
          
          if (response.last_request_at){
            this.recovertext = response.message
          }else
          this.recovertext = response;

        }
      }).catch((err) => {
        console.log(err.response.data.message)
        this.recovertext = err.response.data.message
      });
    },
  },
  watch: {},
  created() {},
};
</script>

<style>
.custom-value {
  border: none;
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  border-bottom: 1px solid #cecece;
  width: 40%;
  background-color: transparent;
}

.custom-value:active {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:hover {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
  cursor: pointer;
}
.custom-value:target {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}

.custom-value:focus {
  border: 0;
  border-bottom: 1px solid #cecece;
  background-color: transparent;
}
</style>
